document.addEventListener('DOMContentLoaded', () => {
  const scrollers = document.querySelectorAll('.collection-scroller');

  scrollers.forEach(scroller => {
    const track = scroller.querySelector('.collection-track');
    const left = scroller.querySelector('.scroller-arrow.left');
    const right = scroller.querySelector('.scroller-arrow.right');

    if (!track) return;

    const scrollAmount = () => Math.round(track.clientWidth * 0.7);

    left.addEventListener('click', () => {
      track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
    });
    right.addEventListener('click', () => {
      track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
    });

    const updateArrows = () => {
      if (!left || !right) return;
      left.style.display = track.scrollLeft > 10 ? 'flex' : 'none';
      right.style.display = (track.scrollWidth - track.clientWidth - track.scrollLeft) > 10 ? 'flex' : 'none';
    };

    track.addEventListener('scroll', updateArrows);
    window.addEventListener('resize', updateArrows);
    updateArrows();

    const items = track.querySelectorAll('.collection-item');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
        }
      });
    }, { root: track, threshold: 0.1 });

    items.forEach(item => observer.observe(item));
  });
});